<ng-template cxOutletRef="CustomerServiceContent" cxOutletPos="after">
  <!-- Customer Service Content (mobile view) -->
  <!-- MOBILE FAQ-->
  @if (isMobile && customerServiceSectionFaq$ | async; as customerServiceSectionFaq) {
  <div class="customer-service-content-mobile d-md-none">
    <div class="customer-service-content-faq-details">
      <h2 class="mb3">{{ customerServiceSectionFaq.title }}</h2>
      @if (customerServiceSectionFaqData$ | async; as customerServiceSectionFaqData) {
      <div class="faq-dropdown-container d-inline-block" display="dynamic" placement="bottom-left" ngbDropdown>
        @if (customerServiceSectionFaqData[activeI]?.title) {
        <button class="btn btn-link p-0" id="faqDropdown" ngbDropdownToggle>
          {{ customerServiceSectionFaqData[activeI].title }}
          <mat-icon class="material-icons-sharp light md-12 ml-1">expand_more</mat-icon>
        </button>
        }
        <div ngbDropdownMenu aria-labelledby="faqDropdown" class="dropdown-menu dropdown-menu-right border-0 rounded-0">
          @for (faqGroup of customerServiceSectionFaqData; track faqGroup; let i = $index) {
          <button ngbDropdownItem (click)="onSelectFaqData(faqGroup, i); activeI = i" [class.selected]="activeI === i">
            @if (activeI === i) {
            <mat-icon svgIcon="check" class="md-12 mr-2"></mat-icon>
            } {{ faqGroup.title }}
          </button>
          }
        </div>
      </div>
      } @if ( customerServiceSectionFaqAccordionData$ | async; as customerServiceSectionFaqAccordionData) {
      <app-accordion [list]="customerServiceSectionFaqAccordionData"></app-accordion>
      } @else { @if (customerServiceContentData$ | async; as customerServiceContentData) { @if
      (lodash.includes(customerServiceContentData[0].typeCode, 'Accordion')) {
      <app-accordion [list]="customerServiceContentData"></app-accordion>
      } } }
    </div>
  </div>
  }
  <!-- MOBILE LINKS-->
  @if (isMobile && customerServiceSectionLinks$ | async; as customerServiceSectionLinks) {
  <div class="customer-service-content-mobile d-md-none">
    <div class="customer-service-content-links-details">
      <h2 class="mb-3">{{ customerServiceSectionLinks.title }}</h2>
      @if (customerServiceSectionLinksData$ | async; as customerServiceSectionLinksData) { @for (link of
      customerServiceSectionLinksData; track link; let i = $index) {
      <cx-generic-link class="d-block mb-3" [url]="link.url" [target]="link.target">{{
        link.linkName
      }}</cx-generic-link>
      } }
    </div>
  </div>
  }
  <!-- MOBILE CONTACT US-->
  @if (isMobile && customerServiceSectionContactUs$ | async; as customerServiceSectionContactUs) {
  <div class="customer-service-content-mobile d-md-none">
    @if (customerServiceSectionContactUsContentData$ | async; as customerServiceSectionContactUsContentData) {
    <div class="customer-service-content-contact-us-details form">
      <h2 class="mb-3">{{ customerServiceSectionContactUs.title }}</h2>
      <ng-container
        [ngTemplateOutlet]="contactUsTemplate"
        [ngTemplateOutletContext]="{ posData: customerServiceSectionContactUsContentData[1] }"
      ></ng-container>
    </div>
    }
  </div>
  }

  <!-- Customer Service Content (desktop view) -->
  @if (!isMobile && customerServiceContentData$ | async; as customerServiceContentData) {
  <div
    class="d-none d-md-block"
    [class.customer-service-content]="lodash.includes(customerServiceContentData[0].typeCode, 'Accordion')"
    [class.form]="!lodash.includes(customerServiceContentData[0].typeCode, 'Accordion')"
    [class.customer-service-content-contact-us-details]="
      !lodash.includes(customerServiceContentData[0].typeCode, 'Accordion')
    "
  >
    @if (lodash.includes(customerServiceContentData[0].typeCode, 'Accordion')) {
    <app-accordion [list]="customerServiceContentData"></app-accordion>
    } @else {
    <ng-container
      [ngTemplateOutlet]="contactUsTemplate"
      [ngTemplateOutletContext]="{ posData: customerServiceContentData[1] }"
    ></ng-container>
    }
  </div>
  }
</ng-template>

<ng-template #contactUsTemplate let-posData="posData">
  <app-dynamic-form
    (formGroupEmit)="updateFormGroup($event)"
    (formModelEmit)="updateFormModel($event)"
    [emitOnInit]="true"
    [formGroupId]="'CONTACT_US'"
    [static]="false"
    [activeLanguage]="activeLanguage$ | async"
    [ngClass]="activeLanguage$ | async"
  ></app-dynamic-form>
  <div class="submit-form-container d-flex justify-content-end">
    <button
      type="button"
      class="btn primary-btn"
      (click)="onSubmitContactUsForm()"
      [class.disabled]="!contactUsFormGroup?.valid || onSubmitContactUsFormInProgress"
      [disabled]="!contactUsFormGroup?.valid || onSubmitContactUsFormInProgress"
      [ngClass]="{
        rotating: onSubmitContactUsFormInProgress
      }"
    >
      {{ onSubmitContactUsFormInProgress ? '' : ('common.submit' | cxTranslate) }}
    </button>
  </div>
  @if (pointsOfService?.length > 0) {
  <div class="points-of-service-container">
    <h3>{{ posData.title }}</h3>
    <div class="d-flex flex-wrap w-100">
      @for (point of pointsOfService | slice : 0 : posData.itemCount; track point; let i = $index) {
      <div class="point-of-service-container">
        <div class="point-of-service-details-container">
          <h4 class="mb-1">{{ point.displayName || point.name }}</h4>
          <span class="d-block value">{{ point.address.formattedAddress }}</span>
          @if (point.address.phone) {
          <span class="mr-1 title">{{ 'customerService.phone' | cxTranslate }}</span>
          <span class="value">{{ point.address.phone }}</span>
          }
          <div class="contact-us-email">
            <span class="mr-1 title" [class.ml-2]="point.address.phone">{{
              'customerService.email' | cxTranslate
            }}</span>
            <span class="value">{{ point.address.email }}</span>
          </div>
          @if (point?.address?.fax) {
          <div class="contact-us-fax">
            <span class="mr-1 title" [class.ml-2]="point.address.fax">{{ 'customerService.fax' | cxTranslate }}</span
            ><span class="value">{{ point.address.fax }}</span>
          </div>
          }
        </div>
      </div>
      }
    </div>
  </div>
  }
</ng-template>
